import React, { Component } from "react";

class Arge extends Component {
  render() {
    const rndData = this.props.rndData || {};
    const lang = this.props.lang || "tr";

    const t = rndData?.translations?.[lang] || {};
    return (
      <div id="i_arge" className="container mb-100">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title-area ltn__section-title-2--- text-center">
              <h1 className="section-title"> {t.title || "AR-GE Çalışmalarımız"}</h1>
            </div>
            <div className="about-us-info-wrap arge-wrap">
              <p>
                {t.content || "AR-GE çalışmalarımız hakkında detaylı bilgi."}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Arge;
